import Styled from 'styled-components';

export interface ITextAreaInputProps {
  alert?: boolean;
  maxWidth?: string;
  minWidth?: string;
  maxHeight?: string;
  minHeight?: string;
}

export const TextAreaInput = Styled.textarea<ITextAreaInputProps>`
  width: 100%;
  background-color: ${({ theme: { input } }) => input.colorTextAreaBackground};
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight};`}
  padding: ${({ theme: { input } }) => input.textAreaPadding};
  position: relative;
  transition: border 0.1s ease-out;
  border: ${({ theme: { input } }) => input.borderWidth} solid ${({ theme: { input } }) => input.colorTextAreaBorder};
  border-radius: ${({ theme: { input } }) => input.borderRadius};

  ${({ theme: { brand, input }, alert }) => alert && `border: ${input.borderWidth} solid ${brand.colorAlert};`}

  &:focus,
  &:hover {
    border: ${({ theme: { input } }) => input.borderWidth} solid ${({ theme: { input } }) => input.colorFocus};
  }

  &::placeholder {
    color: ${({ theme: { input } }) => input.colorPlaceholder};
  }

  &:disabled {
    background: ${({ theme }) => theme.colorSlate5};
  }
`;

TextAreaInput.defaultProps = {
  alert: false
};

TextAreaInput.displayName = 'TextAreaInput';

export default TextAreaInput;
